module.exports = __webpack_public_path__ + "img/Linkedin.86e919ee.png";